import { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { planAmountError } from "../products/types";
import type { PricedCartItem } from "./types";

interface PlanAmountEditorProps {
  item: PricedCartItem;
  disabled: boolean;
  onChange: (amount: number) => void;
}

/** A credits plan's amount on the cart, saved on Enter or when the field loses focus. */
export function PlanAmountEditor({ item, disabled, onChange }: PlanAmountEditorProps) {
  const [raw, setRaw] = useState(String(item.total_price));
  useEffect(() => setRaw(String(item.total_price)), [item.total_price]);

  const error = planAmountError(item, raw);
  const save = () => {
    if (error) return;
    if (Number(raw) !== item.total_price) onChange(Number(raw));
  };

  return (
    <div className="w-40">
      <label className="flex items-center rounded-lg border border-line focus-within:border-brand focus-within:ring-2 focus-within:ring-brand/30">
        <span className="pl-3 text-sm text-ink-3">₹</span>
        <input
          value={raw}
          inputMode="numeric"
          disabled={disabled}
          onChange={(e) => setRaw(e.target.value.replace(/[^\d]/g, ""))}
          onBlur={save}
          onKeyDown={(e) => e.key === "Enter" && save()}
          aria-label={`Amount for ${item.name}`}
          aria-invalid={Boolean(error)}
          className={cn(
            "h-9 w-full rounded-lg bg-transparent px-2 text-sm font-semibold tabular-nums text-ink focus:outline-none disabled:opacity-60",
          )}
        />
      </label>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
}
